export var UserActions = {
    updateUser: 'UPDATE_USER'
};
export var updateUser = function updateUser(user) {
    return {
        type: UserActions.updateUser,
        payload: {
            user: user
        }
    };
};

//# sourceMappingURL=UserActions.js.map